import { set} from '@/utils/vuex'

export default {
    setPractices: set('practices'),
    setUserInfo: set('userInfo'),
    setCurrentActivities: set('currentActivities'),
    setUserName: set('userName'),
    setProfileImage: set('profileImage'),
    setTimesheetData: set('timesheetData'),
    setUsers: set('users')
}